<template>
  <div class="layout-page search-page" >
    <div class="search">
      <a @click="returnPage" class="return"></a>
      <form  style="flex:1" @submit.prevent="seachForm">
         <input type="text" ref="searchIpt" style="width: 100%" v-model.trim="content" placeholder="书名或作者" />
      </form>
      <button
        type="button"
        class="search-btn"
        @click="handleSearch"
      >搜索</button>
    </div>
    <section class="aui-scrollView  no-foot">
      <template v-if="!result">
      <div class="hot-search">
        <h3>热门搜索</h3>
        <ul v-if="getBookSearch.hotWords && getBookSearch.hotWords.length">
          <li v-for="(item,i) in getBookSearch.hotWords" :key="i" @click="handleSearch(item, 'item')">{{item}}</li>
        </ul>
      </div>
      <div class="hot-search">
        <h3>
          搜索历史
          <a href="#"></a>
        </h3>
        <ul>
          <li v-for="(item,index) in searchHistory" :key="index" @click="handleSearch(item, 'item')">{{item}}</li>
        </ul>
      </div>
      </template>
      <books-large
      style="margin-top: 10px"
        v-else
        :show-more="false"
        :books="list"
      ></books-large>
      <loading
        ref="loading"
        :isScroll="false"
        :is-loading="isLoading"
        :is-no-more-data="isNoMoreData"
      ></loading>
    </section>
  </div>
</template>

<script>
import BooksLarge from '@/components/share/books-large'
import SearchService from '../../../services/searchService'
import Loading from '../../../components/share/loading'
import { mapGetters } from 'vuex'
export default {
  name: 'search-result',
  data () {
    return {
      content: '',
      isLoading: false,
      result: false,
      isNoMoreData: false,
      searchHistory: [],
      list: []
    }
  },
  computed: {
    ...mapGetters(['getBookSearch'])
  },
  components: { BooksLarge, Loading },
  methods: {
    returnPage () {
      this.$router.isBack = true
      this.$router.go(-1)
    },
    returnHome () {
      this.$router.isBack = false
      this.$router.push('/home')
    },
    getSearchHistory () {
      const list = window.localStorage.getItem('$_search_history')
      if (list) {
        return list.split(',')
      }
      return []
    },
    setSearchHistory () {
      try {
        const list = this.getSearchHistory()
        const { content } = this
        const index = list.findIndex(item => item === content)
        if (index > -1) {
          list.splice(index, 1)
        }
        list.unshift(content)
        this.searchHistory = list
        window.localStorage.setItem('$_search_history', list)
      } catch (error) {
      }
    },

    bookSearch () {
      const { content } = this
      if (!content) return
      this.result = true
      this.isLoading = true
      SearchService.bookSearch(content).then(res => {
        const resData = res.data || []
        this.list = resData
        this.isLoading = false
        if (this.list.length === 0) {
          this.isNoMoreData = true
        }
      })
    },
    handleSearch (content, type) {
      if (!content) return
      if (type === 'item') {
        this.content = content
      }
      this.setSearchHistory()
      this.bookSearch()
    },
    seachForm () {
      this.handleSearch()
      return false
    }
  },
  watch: {
    content (val) {
      if (!val) {
        this.result = false
        this.list = []
      }
    }
  },
  mounted () {
    this.searchHistory = this.getSearchHistory()
    const timer = setTimeout(() => {
      this.$refs.searchIpt.focus()
      clearTimeout(timer)
    }, 600)
  }
}
</script>
 <style lang="less" scoped>
   .search-page{
     .search{
       position:fixed;
       top: 0;
       left: 0;
       width: 100%;
       z-index: 10;
     }
     .aui-scrollView {
       padding-top: 50px;
     }
   }
 </style>
